export enum DiscountType {
  PromoDiscount = 'promoDiscount',
  CreditToTrainline = 'creditToTrainline',
}

export default DiscountType;
